import { render, staticRenderFns } from "./CommonChoice.vue?vue&type=template&id=6301a747&scoped=true"
import script from "./CommonChoice.vue?vue&type=script&lang=js"
export * from "./CommonChoice.vue?vue&type=script&lang=js"
import style0 from "./CommonChoice.vue?vue&type=style&index=0&id=6301a747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301a747",
  null
  
)

export default component.exports